export default __webpack_public_path__ + "imgs/icon3.png";